import { Avatar, Col, Dropdown, Row } from "antd";
import React, { useState } from "react";
import { FaUserTie } from "react-icons/fa";
import { MdBlockFlipped } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import ChatMessages from "./ChatMessages";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../../../components/Modal";
import Prompt from "../../../../components/Prompt";
import { setMessage } from "../../../../store/common/generalSlice";
import useChatApi from "../../../../config/hooks/api/chats/useChatApi";

const ChatBody = ({ data, hasChats }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { blockUser } = useChatApi();

  const { loggedInUser } = useSelector((state) => state?.auth);

  const [showBlockPrompt, setShowBlockPrompt] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [isChannelBlocked, setIsChannelBlocked] = useState(false);
  const [isBlockedByReceipient, setIsBlockedByReceipient] = useState(false);

  const blockPromptMessage = `Are you sure you want to block this user?`;

  const getReceipientData = (chatMembers) => {
    if (chatMembers && chatMembers.length) {
      return chatMembers.filter((e) => e.memberId != loggedInUser?.id)[0];
    }
  };

  const receipientData = getReceipientData(data?.chatMembers);
  const receipientUser = receipientData?.user || data?.user;
  const isServiceProvider =
    receipientUser?.type?.toLowerCase()?.includes("provider");

  const items = [];
  if (isServiceProvider) {
    items.push({
      label: "View Profile",
      key: "0",
      icon: <FaUserTie className="icon-msg" />,
    });
    items.push({
      type: "divider",
    });
  }
  items.push({
    label: "Block User",
    key: "1",
    icon: <MdBlockFlipped className="icon-alert" />,
  });

  const handleMenu = (e) => {
    if (!e) return;
    const { key } = e;
    if (key == 0) {
      const targetUserId =
        receipientUser?.id || receipientData?.memberId || data?.user?.id;
      if (targetUserId) {
        navigate(`/profile/${targetUserId}`);
      }
    } else {
      setShowBlockPrompt(true);
    }
  };

  const menuProps = {
    items:
      isChannelBlocked || isBlockedByReceipient
        ? items.filter((e) => e.key == 0)
        : items,
    onClick: handleMenu,
  };

  const handleBlockUser = async () => {
    try {
      const receipient = getReceipientData(data?.chatMembers);
      if (!receipient) return;

      const response = await blockUser({
        otherUserId: receipient?.memberId,
      });
      if (response) {
        dispatch(setMessage(response?.data?.message));
        setRefresh(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleBlockPromptResponse = (res) => {
    if (res === true) handleBlockUser();
    closeModal();
  };

  const closeModal = () => {
    setShowBlockPrompt(false);
  };

  return (
    <React.Fragment>
      {data ? (
        <Row>
          <Col span={24} className="sm:pr-6 sm:pt-3 p-2 border-l-2">
            <div className="flex items-center justify-between p-2 rounded-md bg-slate-200 mb-6">
              <div className="flex items-center h-[60px]">
                <div className="rounded-full w-[60px] h-[100%]">
                  <Avatar
                    src={
                      getReceipientData(data?.chatMembers)?.user?.imageThumbUrl
                    }
                    className="w-full h-full object-contain"
                  >
                    {getReceipientData(data?.chatMembers)
                      ?.user?.fullName?.charAt(0)
                      ?.toUpperCase()}
                  </Avatar>
                </div>
                <div className="flex p-2 ml-2">
                  <h6 className={`heading-6 font-bold`}>
                    {getReceipientData(data?.chatMembers)?.user?.fullName}
                  </h6>
                </div>
              </div>
              <div>
                <Dropdown.Button
                  menu={menuProps}
                  trigger={["click"]}
                ></Dropdown.Button>
              </div>
            </div>
            <ChatMessages
              chatData={data}
              refreshData={refresh}
              resetRefreshData={() => setRefresh(false)}
              handleBlockedChannel={(res) => setIsChannelBlocked(res)}
              isMessageSenderBlocked={(val) => setIsBlockedByReceipient(val)}
            />
          </Col>
        </Row>
      ) : (
        <div className="flex p-4 justify-center">
          <h6 className="heading-6 text-sm font-semibold text-gray-400">
            {hasChats
              ? "Please select a chat to start conversation"
              : "chats not available"}
          </h6>
        </div>
      )}
      <Modal.Basic
        id="blockPrompt"
        open={showBlockPrompt}
        onCancel={closeModal}
        width={250}
      >
        <Prompt.Basic
          message={blockPromptMessage}
          onChange={handleBlockPromptResponse}
          closeModal={closeModal}
        />
      </Modal.Basic>
    </React.Fragment>
  );
};

export default ChatBody;
